import type { VChartSpecPipeline } from 'src/types'
import {
  initScatter,
  colorAdapter,
  color,
  linearColor,
  backgroundColor,
  progressive,
  brush,
  discreteLegend,
  colorLegend,
  verticalCrosshairLine,
  colorPointStyleFill,
  pointStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  playerScatter,
  xLinear,
  yLinear,
  scatterSize,
  labelScatter,
  tooltipScatter,
  horizontalCrosshairLine,
  pointStateHover,
  annotationArea,
  linearRegressionLine,
  lowessRegressionLine,
  polynomialRegressionLine,
  logisticRegressionLine,
  datasetScatter,
  isPlayer,
  fontFamilyTheme,
} from '../pipes'
const raceScatter: VChartSpecPipeline = [
  fontFamilyTheme,
  initScatter,
  colorAdapter(color, linearColor),
  backgroundColor,
  isPlayer(playerScatter, datasetScatter),
  progressive,
  xLinear,
  yLinear,
  brush,
  scatterSize,
  labelScatter,
  tooltipScatter,
  colorAdapter(discreteLegend, colorLegend),
  verticalCrosshairLine,
  horizontalCrosshairLine,
  colorPointStyleFill(pointStyle),
  pointStateHover,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  linearRegressionLine,
  lowessRegressionLine,
  polynomialRegressionLine,
  logisticRegressionLine,
]

export const raceScatterSpecPipeline = raceScatter
